<template>
  <div class="container">
    <b-card header-tag="header">
      <template #header>
        <b-row align-h="between" align-v="center">
          <h4 class="card-tittle">Detalle de Contrato</h4>
          <b-button variant="dark" @click="back()">Volver </b-button>
        </b-row>
      </template>

      <div v-if="isBusy" class="text-center text-danger space">
        <b-spinner class="align-middle"></b-spinner>
      </div>
      
      <template v-if="!isBusy">
        <b-row align-h="between" align-v="center" class="contentRow">
          <template v-if="data">         

            <!-- INICIO PRIMERA ROW -->
            <b-row align-h="between" align-v="center" class="mainRow">
              <b-col cols="4" class="redCol alto100"> DATOS DEL CONTRATO </b-col>
              <b-col cols="8">
                <p>
                  Número de contrato:
                  <b>{{
                    data.contrato
                      ? data.contrato
                      : " No especificado"
                  }}</b>
                </p>            
                <p>
                  Fecha:
                  <b>{{
                    data.fecha ? formatFecha(data.fecha) : "No especificada"
                  }}</b>
                </p>
              </b-col>
            </b-row>
            <!-- INICIO SEGUNDA ROW -->
            <b-row align-h="between" align-v="center" class="mainRow">
              <b-col cols="4" class="redCol alto100"> DATOS DE SALIDA </b-col>
              <b-col cols="8">
                <p>
                  Fecha:
                  <b>{{
                    data.fechaSalida
                      ? formatFecha(data.fechaSalida)
                      : " No especificada"
                  }}</b>
                </p>            
                <p>
                  Sucursal:
                  <b>{{
                    data.sucursalSalida ? data.sucursalSalida : "No especificada"
                  }}</b>
                </p> 
              </b-col>
            </b-row>
            <!-- INICIO TERCERA ROW -->
            <b-row align-h="between" align-v="center" class="mainRow">
              <b-col cols="4" class="redCol alto100"> DATOS DE DEVOLUCIÓN </b-col>
              <b-col cols="8">
                <p>
                  Fecha:
                  <b>{{
                    data.fechaDevolucion
                      ? formatFecha(data.fechaDevolucion)
                      : " No especificada"
                  }}</b>
                </p>            
                <p>
                  Sucursal:
                  <b>{{
                    data.sucursalDevolucion ? data.sucursalDevolucion : "No especificada"
                  }}</b>
                </p> 
              </b-col>
            </b-row>
            <!-- INICIO CUARTA ROW -->
            <template v-if="data.conductores">
              <b-row align-h="between" align-v="center" class="mainRow">
                <b-col cols="4" class="redCol"> DATOS DE CONDUCTOR </b-col>
                <b-col cols="8">
                  <template v-if="data.conductores.length > 0">
                    <p>
                      R.U.T:
                      <b>{{
                        data.conductores[0].rut
                          ? data.conductores[0].rut
                          : " No especificado"
                      }}</b>
                    </p>            
                    <p>
                      Nombre:
                      <b>{{
                        data.conductores[0].nombre ? data.conductores[0].nombre : "No especificado"
                      }}</b>
                    </p>
                    <p>
                      Licencia:
                      <b>{{
                        data.conductores[0].codigoLicencia ? data.conductores[0].codigoLicencia : "No especificada"
                      }}</b>
                    </p>
                    <p>
                      Exp:
                      <b>{{
                        data.conductores[0].fechaExpiraLicencia ? 
                        formatFecha(data.conductores[0].fechaExpiraLicencia) : 
                        "No especificada"
                      }}</b>
                    </p>
                  </template>
                  <div v-else>
                    <p>Conductores no especificados</p>
                  </div>
                </b-col>
              </b-row>
              <!-- INICIO ROWS OTROS CONDUCTORES -->     
              <template v-if="data.conductores.length > 1">        
                <b-row
                align-h="between" 
                align-v="center" 
                class="mainRow" 
                v-for="(conductor, index) in data.conductores" :key="conductor.rut">
                  <template v-if="index > 0">
                    <b-col cols="4" class="redCol"> OTRO CONDUCTOR </b-col>
                    <b-col cols="8">
                        <p>
                          R.U.T:
                          <b>{{
                            data.conductores[index].rut
                              ? data.conductores[index].rut
                              : " No especificado"
                          }}</b>
                        </p>            
                        <p>
                          Nombre:
                          <b>{{
                            data.conductores[index].nombre ? data.conductores[index].nombre : "No especificado"
                          }}</b>
                        </p>
                        <p>
                          Licencia:
                          <b>{{
                            data.conductores[index].codigoLicencia ? data.conductores[index].codigoLicencia : "No especificada"
                          }}</b>
                        </p>
                        <p>
                          Exp:
                          <b>{{
                            data.conductores[index].fechaExpiraLicencia ? 
                            formatFecha(data.conductores[index].fechaExpiraLicencia) : 
                            "No especificada"
                          }}</b>
                        </p>
                    </b-col>
                  </template>            
                </b-row>
              </template>
            </template>
            <!-- INICIO QUINTA ROW -->
            <b-row align-h="between" align-v="center" class="mainRow">
              <b-col cols="4" class="redCol alto150"> DATOS DE FACTURACIÓN </b-col>
              <b-col cols="8">
                <p>
                  R.U.T:
                  <b>{{
                    data.rutFacturacion
                      ? data.rutFacturacion
                      : " No especificado"
                  }}</b>
                </p>            
                <p>
                  Nombre:
                  <b>{{
                    data.nombreFacturacion ? data.nombreFacturacion : "No especificado"
                  }}</b>
                </p> 
              </b-col>
            </b-row>
            <!-- INICIO SEXTA ROW -->
            <b-row align-h="between" align-v="center" class="mainRow">
              <b-col cols="4" class="redCol alto250"> DATOS DE VEHÍCULO </b-col>
              <b-col cols="8">
                <p>
                  Patente:
                  <b>{{
                    data.vehiculo.patente
                      ? data.vehiculo.patente
                      : " No especificada"
                  }}</b>
                </p>            
                <p>
                  KM:
                  <b>{{
                    data.vehiculo.kmSalida ? data.vehiculo.kmSalida : "No especificado"
                  }}</b>
                </p> 
                <p>
                  Vehículo:
                  <b>{{
                    data.vehiculo.tipoVehiculo ? data.vehiculo.tipoVehiculo : "No especificado"
                  }}</b>
                </p>
                <p>
                  Marca:
                  <b>{{
                    data.vehiculo.marcaVehiculo ? data.vehiculo.marcaVehiculo : "No especificada"
                  }}</b>
                </p>
                <p>
                  Modelo:
                  <b>{{
                    data.vehiculo.modeloVehiculo ? data.vehiculo.modeloVehiculo : "No especificado"
                  }}</b>
                </p>
                <p>
                  Color:
                  <b>{{
                    data.vehiculo.colorVehiculo ? data.vehiculo.colorVehiculo : "No especificado"
                  }}</b>
                </p>
              </b-col>
            </b-row>

          </template>
          <template v-else>
            <h3 class="text-center">No se encontró el contrato</h3>
          </template>
        </b-row>
      </template>
      
    </b-card>
    </div>
</template>

<script>
import axios from "@/axios";
import moment from "moment";
export default {
  data() {
    return {
      data: [],
      isBusy: false,
    };
  },
  beforeMount() {
    this.getDetail();
  },
  methods: {
    back() {
      history.back();
    },
    getDetail() {
      this.isBusy = true;
      axios
        .get(`GetContratoByNumero/${this.$store.getters["hideValue/detailId"]}`)
        .then((detalle) => {
          this.isBusy = false;
          this.data = detalle.data;
        })
        .catch(() => {
          this.$bvToast.toast(
            this.$t("lease.request.error.message").toString(),
            {
              title: this.$t("lease.request.error.nonFound").toString(),
              variant: "danger",
              solid: true,
            }
          );
          this.isBusy = false;
        });
    },
    formatFecha(fecha){
      return moment(fecha).format("DD-MM-YYYY") + " " + moment(fecha).format("HH:mm:ss")
    }
  },
};
</script>

<style scoped>
.card{
  width: 40% !important;
  margin-left: 30% !important;
}
.mainRow {
  width: 100%;
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 0.2em;
}
.redCol {
  background-color: #e2231a;
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  font-size: 0.8125rem;
  font: 200;
  text-align: center;
}
.redRow {
  background-color: #e2231a;
  color: white;
  padding-left: 1em;
  padding-right: 1em;
  margin-bottom: 3em;
}
.card {
  width: 90%;
  margin-left: 5%;
  margin-top: 24px;
}
.card-tittle {
  font-size: 1.5rem;
  padding: 1rem;
  color: white;
}
.colImg {
  text-align: center;
}
.card-header {
  background-color: #e2231a;
}
img{
  height: 200px;
}
.alto100{
  height: 100px !important;
}
.alto150{
  height: 150px !important;
}
.alto250{
  height: 250px !important;
}
</style>